import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';
import { UserType } from '../../../enums/UserType';
import { filenameFromContentDisposition } from '../../../utils/downloadBlob';

// awards-service splits each report by a required query filter: applications by
// the applicant's user type, feedback by review direction. "Offices" is the
// office side of that split, "Pros" the professional side. The filter is
// required — a missing one is a 400, not a merged file. Both the param name and
// its wire values live here so the whole filter contract sits in one place.
const EXPORTS = {
  applications: {
    param: 'userType',
    values: { Offices: UserType.DNT, Pros: UserType.HYG },
  },
  feedback: {
    param: 'direction',
    values: {
      Offices: 'office-reviews-professional',
      Pros: 'professional-reviews-office',
    },
  },
};

/**
 * Fetch one cycle export. awards-service streams these as CSV (not JSON), so
 * they are fetched as a blob; the filename comes from Content-Disposition with
 * a sensible fallback. The caller passes the UI concepts (kind + audience) and
 * this maps them to the query the service expects.
 */
export const downloadCycleExport = async ({ cycleId, kind, audience }) => {
  const { param, values } = EXPORTS[kind];
  const filter = values[audience];

  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(
    `/awards-service-api/admin/cycles/${cycleId}/exports/${kind}`,
    { headers, params: { [param]: filter }, responseType: 'blob' },
  );

  return {
    blob: response.data,
    filename: filenameFromContentDisposition(
      response.headers,
      `best-in-dental-${kind}-${filter}.csv`,
    ),
  };
};
